import Axios from "axios";
import React from "react";
import { sortCaret } from "../../../_metronic/_helpers";
const base_ul = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/products";


export const columns_campaign = [
  {
    dataField: "count",
    text: "No",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      width: "80px",
    },
    formatter: (c, r, i) => i + 1

  },
  {
    dataField: "image",
    text: "Image",
    sort: true,
    sortCaret: sortCaret,

    rowStyle: {
      height: "100px"
    },
    formatter: (cell, row, i, addons = {}) => {
      return (

        <img
          alt="product"
          className="i,mage-fluid rounded cursor-pointer"
          height="90px"
          onClick={() => typeof addons.controller === "function" && addons.controller(row)}
          width="90px"
          src={row.image || row.logo_url || process.env.REACT_APP_DEFAULT_PRODUCT_IMAGE}
        />

      )
    }
  },
  {
    dataField: "name",
    text: "Name",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "volume",
    text: "Volume/Metric",
    sort: true,
    sortCaret: sortCaret,
    formatter: (cellContent, row) => <>{row.volume} {row?.metric}</>,

  },
  {
    dataField: "cost",
    text: "Cost",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "price",
    text: "SRP",
    sort: true,
    sortCaret: sortCaret,
    formatter: (cellContent, row) => <>${Number(row?.price).toFixed(2)}</>,
  },
  {
    dataField: "catego,ry",
    text: "Category",
    sort: true,
    sortCaret: sortCaret,
  },
];

export const columns = [
  {
    dataField: "count",
    text: "No",
    sort: true,
    sortCaret: sortCaret,
    headerStyle: {
      width: "80px",
    },
    formatter: (c, r, i) => i + 1

  },
  {
    dataField: "image",
    text: "Image",
    sort: true,
    sortCaret: sortCaret,

    rowStyle: {
      height: "100px"
    },
    formatter: (cell, row, i, addons = {}) => {
      return (

        <img
          alt="product"
          className="i,mage-fluid rounded cursor-pointer"
          height="90px"
          onClick={() => typeof addons.controller === "function" && addons.controller(row)}
          width="90px"
          src={row.image || row.logo_url || process.env.REACT_APP_DEFAULT_PRODUCT_IMAGE}
        />

      )
    }
  },
  {
    dataField: "name",
    text: "Name",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "manufacture",
    text: "Client",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "volume",
    text: "Volume/Metric",
    sort: true,
    sortCaret: sortCaret,
    formatter: (cellContent, row) => <>{row.volume} {row?.metric}</>,

  },
  {
    dataField: "cost",
    text: "Cost",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "price",
    text: "SRP",
    sort: true,
    sortCaret: sortCaret,
    formatter: (cellContent, row) => <>${Number(row?.price).toFixed(2)}</>,
  },
  {
    dataField: "catego,ry",
    text: "Category",
    sort: true,
    sortCaret: sortCaret,
  },
];

export function getClients(callback) {
  Axios.post(`${base_ul}/find/all`)
    .then((res) => {
      callback(res.data.payload);
    })
    .catch((err) => { });
}
export function getAll() {
  return Axios.post(`${base_ul}/find/all`)
}
export function getLast(n = 4) {
  return Axios.get(`${base_ul}/last/${n}`)
}
export function getClient(uid = "") {
  return Axios.get(`${base_ul}/${uid}`);
}

export function getCompetition(uid = "") {
  return Axios.get(`${base_ul}/competition/${uid}`);
}

export function updateClient(product) {
  if (product.uid) {
    return Axios.put(`${base_ul}/update/${product.uid}`, product);
  } else {
    return Axios.post(`${base_ul}/create`, { product });
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${base_ul}/delete/${uid}`);
}